import './App.css';
import Divider from '@material-ui/core/Divider';

function Blog() {
    return (
      <div align="left" className="content_page">
          <h1 className="content_page">
            August 2021
          </h1>
          <Divider /> 
          <p>
            "We're not in Kansas anymore", said a very confused Dorothy to an even more confused Toto. Same here 
            (but less confused). Just moved to Pittsburgh, and I am thrilled to start grad school at 
            Carnegie Mellon this fall! (no flying monkeys yet, but I'll let you know of any sightings.)
          </p>
          <br />

          <h1 className="content_page">
            July 2021
          </h1>
          <Divider />
          <p>
            Published website. Hello world :)
          </p>
      </div>
    );
  }
  
  export default Blog;
  